<template>
  <div>
    <b-overlay
        :show="uploading"
        spinner-variant="primary"
        rounded="sm"
    >
    <b-table
      :items="filesList"
      :fields="fields"
      responsive
      show-empty
      thead-class="esep-blue-bg text-light"
    >
      <template v-slot:cell(action)="row">
        <b-button
          v-if="row.item.id != -1"
          size="sm"
          @click="downloadAttachment(row)"
          variant="transparent"
          v-b-tooltip.hover
          title="Κατέβασμα Αρχείου"
        >
          <b-icon icon="box-arrow-down"></b-icon>
        </b-button>

        <b-button
          v-if="row.item.id != -1 && !viewOnly"
          size="sm"
          @click="deleteAttachment(row)"
          variant="transparent"
          v-b-tooltip.hover
          title="Διαγραφή Αρχείου"
        >
          <b-icon icon="trash"></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>Δεν έχουν προστεθεί αρχεία</h6>
      </template>

    </b-table>
    <b-row class="ml-3" v-if="!viewOnly">

      <b-form-file
        v-model="attachment.file"
        :state="Boolean(attachment.file)"
        placeholder="Επιλέξτε αρχείο..."
        drop-placeholder="Αφήστε το αρχείο εδώ..."
        class="col-6"
      ></b-form-file>
      <b-button v-if="!viewOnly"  class="esep-blue-bg ml-2" variant="primary" @click="uploadAttachment" :disabled="!this.attachment.file">
        Ανέβασμα Αρχείου
      </b-button>
    </b-row>

    </b-overlay>
  </div>
</template>

<script>
import {prettifyDate} from "../services/utils";
import trainingService from '../services/training.service';
import { handleApiError } from '../services/error.service';

export default {
  props: {
    viewOnly: Boolean,
    applyActivity: Object
  },
  mounted() {
    this.getAttachments();
  },
  data() {
    return {
      filesList: [],
      uploading:false,
      fields: [
        { key:'filename', label: "Αρχείο", thClass: 'text-left', tdClass: 'text-left' },
        { key:'dateCreated', label: "Ημ/νία Υποβολής", formatter: "prettifyDate" },
        { key:'action', label: "Ενέργεια" },
      ],
      attachment: {
        file: null,
        information: null,
        type: null
      }      
    }
  },
  methods: {
    deleteAttachment(row) {
      this.uploading = true;
      trainingService.deleteApplyFile(this.applyActivity.id, row.item.id).then(
          () => {
            for (let j = 0; j < this.filesList.length; j++) {
              const a = this.filesList[j];
              if(a.id == row.item.id) {
                this.filesList.splice(j,1);
                j = this.filesList.length;
              }
            }
            this.uploading = false;
            this.makeToast("Το αρχείο διαγράφηκε.")
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.makeFailToast(errorMessage? errorMessage: "Σφάλμα Εφαρμογής")
            this.uploading = false;
          }
      )
    },
    uploadAttachment() {
      this.uploading = true;
      trainingService.uploadApplyFile(this.applyActivity.id, this.attachment.file).then(
          (response) => {
            this.filesList.push(response.data);
            this.uploading = false;
            this.makeToast("Το αρχείο ανέβηκε με επιτυχία.")
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.makeFailToast(errorMessage? errorMessage: "Σφάλμα Εφαρμογής")
            this.uploading = false;
          }
      )
    },
    downloadAttachment(row) {
      const fileDownload = require('js-file-download');
      trainingService.downloadAttachment(this.applyActivity.id, row.item).then(
          (response) => {
            fileDownload(response.data, `${row.item.filename}`);
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.$emit('error:api', errorMessage);
          }
      )
    },
    prettifyDate (stringDate) {
      return prettifyDate(stringDate);
    },
    getAttachments() {
      trainingService.getApplyActivityAttachments(this.applyActivity.id).then(
          (response) => {
            this.filesList = response.data;
          },
          (error) => {
            let errorMessage = handleApiError(error);
            this.handleError(errorMessage);
          }
      )
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        variant: 'success',
        title: 'Επιτυχία',
        solid: true
      })
    },
    makeFailToast(msg) {
      this.$bvToast.toast(msg, {
        variant: 'danger',
        title: 'Σφάλμα',
        solid: true
      })
    },
  },

}
</script>

<style>

</style>